import React from "react";
import { useEffect } from "react";
import "./App.css";
import { useDispatch } from "react-redux";
import AppRouter from "./AppRouter";
import { InitializeApp } from "actions/AppActions";
import { BrowserRouter } from "react-router-dom";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(InitializeApp());
  }, []);

  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
